import React from 'react';
import { WorkflowList } from '../../components/Workflow/WorkflowList';

const WorkflowsPage: React.FC = () => (
  <div className="flex-1">
    <div className="max-w-7xl mx-auto">
      <WorkflowList />
    </div>
  </div>
);

export default WorkflowsPage;
